import React from 'react';
import { format } from 'date-fns';

const ReceiptTemplate = React.forwardRef(({ receipt }, ref) => {
    if (!receipt) return null;

    // A simple number to words function
    const numberToWords = (num) => {
        const a = ['','One ','Two ','Three ','Four ', 'Five ','Six ','Seven ','Eight ','Nine ','Ten ','Eleven ','Twelve ','Thirteen ','Fourteen ','Fifteen ','Sixteen ','Seventeen ','Eighteen ','Nineteen '];
        const b = ['', '', 'Twenty','Thirty','Forty','Fifty', 'Sixty','Seventy','Eighty','Ninety'];
        
        if ((num = num.toString()).length > 9) return 'overflow';
        let n = ('000000000' + num).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
        if (!n) return '';
        let str = '';
        str += (n[1] != 0) ? (a[Number(n[1])] || b[n[1][0]] + ' ' + a[n[1][1]]) + 'Crore ' : '';
        str += (n[2] != 0) ? (a[Number(n[2])] || b[n[2][0]] + ' ' + a[n[2][1]]) + 'Lakh ' : '';
        str += (n[3] != 0) ? (a[Number(n[3])] || b[n[3][0]] + ' ' + a[n[3][1]]) + 'Thousand ' : '';
        str += (n[4] != 0) ? (a[Number(n[4])] || b[n[4][0]] + ' ' + a[n[4][1]]) + 'Hundred ' : '';
        str += (n[5] != 0) ? ((str != '') ? 'and ' : '') + (a[Number(n[5])] || b[n[5][0]] + ' ' + a[n[5][1]]) : '';
        return str.trim() ? str.trim() + ' Only' : 'Zero';
    };

    const formatDate = (dateString) => {
        if (!dateString) return '-';
        try {
            return format(new Date(dateString), 'd-MMM-yy');
        } catch(e) { return '-'; }
    };

    const amountInWords = numberToWords(Math.floor(Number(receipt.amount || 0)));
    
    // Address format
    const addressLines = [
        receipt.member_address || '',
        [receipt.city, receipt.sub_district].filter(a => a && a !== "Not Applicable").join(", "),
        [receipt.district, receipt.state].filter(a => a && a !== "Not Applicable").join(", ") + (receipt.pin_code ? ` - ${receipt.pin_code}` : '')
    ].filter(Boolean);

    // Designation
    const designation = receipt.leadership_designation || receipt.member_type_choice || 'Member';
    const place = receipt.leadership_place || receipt.leadership_wing || '';
    const fullDesignation = `${place} ${designation}`.trim();

    return (
        <div ref={ref} style={{ width: '800px', backgroundColor: 'white', padding: '40px', fontFamily: '"Arial", sans-serif', color: 'black' }} className="receipt-pdf-container">
            {/* Header */}
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
                <div style={{ fontWeight: 'bold' }}>
                    <div>Invoice No. <span style={{ marginLeft: '10px' }}>{receipt.id}</span></div>
                    <div>Ref. No. <span style={{ marginLeft: '25px', fontWeight: 'normal' }}>{receipt.receipt_number || ''}</span></div>
                </div>
                <div style={{ fontWeight: 'bold' }}>
                    Dated <span style={{ marginLeft: '10px' }}>{formatDate(receipt.payment_date)}</span>
                </div>
            </div>

            {/* Central Info */}
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '30px' }}>
                <div style={{ width: '150px' }}>
                    {/* Inline Logo, assuming /images/nailogo.png is served correctly. In Canvas, base64 is safest but local relative URL usually works if same-origin. */}
                    <img src="/images/nailogo.png" alt="NAI Logo" style={{ width: '100px', height: 'auto' }} />
                </div>
                <div style={{ flex: 1, textAlign: 'center' }}>
                    <div style={{ fontWeight: 'bold', fontSize: '18px', marginBottom: '5px' }}>DMCR NEWSMEDIA ASSOCIATION</div>
                    <div style={{ fontSize: '14px', lineHeight: '1.4' }}>
                        Laxmi Narains Tower, 3rd Floor, 71/72,<br />
                        Wallajah Road, Chennai - 600 002.<br />
                        E-Mail : dmcrnewsmedia@gmail.com
                    </div>
                </div>
                <div style={{ width: '150px' }}></div> {/* Spacer for centering */}
            </div>

            {/* Receipt Title */}
            <div style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '18px', marginBottom: '20px' }}>
                RECEIPT
            </div>

            {/* Party Info */}
            <div style={{ display: 'flex', marginBottom: '20px' }}>
                <div style={{ width: '80px', fontSize: '15px' }}>Party :</div>
                <div style={{ fontSize: '15px' }}>
                    <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>{receipt.member_name}</div>
                    {addressLines.map((line, idx) => (
                        <div key={idx} style={{ textTransform: 'uppercase' }}>{line}</div>
                    ))}
                </div>
            </div>

            {/* Invoice Table */}
            <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid black', fontSize: '14px' }}>
                <thead>
                    <tr>
                        <th colSpan="2" style={{ border: '1px solid black', borderBottom: 'none', padding: '5px', textAlign: 'left', fontWeight: 'bold', width: '50%' }}>
                            Dispatch Doc No.<br />
                            <span style={{ fontWeight: 'normal' }}>CR.ID: {receipt.member_id_str}</span><br />
                            <span style={{ fontWeight: 'normal' }}>Through : Post</span>
                        </th>
                        <th colSpan="2" style={{ border: '1px solid black', borderBottom: 'none', padding: '5px', textAlign: 'left', fontWeight: 'bold', width: '50%' }}>
                            Delivery Note<br />
                            <span style={{ fontWeight: 'normal' }}>1 dt. {formatDate(receipt.payment_date)}</span><br />
                            <span style={{ fontWeight: 'normal' }}>To : {receipt.district || receipt.city || ''}</span>
                        </th>
                    </tr>
                    <tr>
                        <th style={{ border: '1px solid black', padding: '5px', width: '5%', textAlign: 'center' }}>Sl<br/>No.</th>
                        <th colSpan="2" style={{ border: '1px solid black', padding: '5px', textAlign: 'center' }}>Particulars</th>
                        <th style={{ border: '1px solid black', padding: '5px', width: '20%', textAlign: 'center' }}>Amount</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td style={{ borderLeft: '1px solid black', borderRight: '1px solid black', padding: '5px', verticalAlign: 'top', height: '300px', textAlign: 'center' }}>
                            1
                        </td>
                        <td colSpan="2" style={{ borderRight: '1px solid black', padding: '10px 5px', verticalAlign: 'top' }}>
                            <div style={{ fontWeight: 'bold' }}>
                                {receipt.payment_type ? receipt.payment_type.toUpperCase() + ' FEE' : 'MEMBERSHIP RENEWAL FEE'}
                            </div>
                            <div style={{ fontStyle: 'italic', marginTop: '5px' }}>
                                {fullDesignation}
                            </div>
                        </td>
                        <td style={{ borderRight: '1px solid black', padding: '10px 5px', verticalAlign: 'top', textAlign: 'right', fontWeight: 'bold' }}>
                            {Number(receipt.amount || 0).toFixed(2)}
                        </td>
                    </tr>
                    <tr>
                        <td colSpan="3" style={{ border: '1px solid black', padding: '5px', textAlign: 'right' }}>Total</td>
                        <td style={{ border: '1px solid black', padding: '5px', textAlign: 'right', fontWeight: 'bold' }}>
                            ₹ {Number(receipt.amount || 0).toFixed(2)}
                        </td>
                    </tr>
                </tbody>
            </table>

            {/* Amount In Words & Footer */}
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '5px', fontSize: '13px' }}>
                <div>Amount Chargeable (in words)</div>
                <div style={{ fontStyle: 'italic' }}>E. & O.E</div>
            </div>
            <div style={{ fontWeight: 'bold', fontSize: '15px', marginTop: '5px' }}>
                INR {amountInWords}
            </div>

            {/* Declaration & Signatory */}
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '30px', fontSize: '13px' }}>
                <div style={{ width: '45%' }}>
                    <div style={{ textDecoration: 'underline', marginBottom: '5px' }}>Declaration</div>
                    <div>
                        The Funds collected from you will be used for welfare of the association. Administration expenses and of its members or for the society development work. Cannot be refunded at any cost.
                    </div>
                </div>
                <div style={{ width: '45%', textAlign: 'right', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                    <div style={{ fontWeight: 'bold', fontSize: '14px' }}>for DMCR NEWSMEDIA ASSOCIATION</div>
                    <div style={{ marginTop: '50px' }}>Authorised Signatory</div>
                </div>
            </div>

            <div style={{ textAlign: 'center', marginTop: '40px', fontSize: '12px', textDecoration: 'underline' }}>
                This is a Computer Generated Invoice
            </div>
        </div>
    );
});

export default ReceiptTemplate;
